import { SECRETARIAT_ROLE_ID } from 'constants/roles'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'

export function canSecretariatRemoveDraft (profile, site) {
  const roleId = profile?.RoleId ?? profile?.Role?.id
  const statusId = Number(site?.SiteStatus?.id ?? site?.SiteStatusId)
  return (
    roleId === SECRETARIAT_ROLE_ID &&
    statusId === SITE_STATUS_DRAFT_ID
  )
}

export function canProfileSelfRemoveDraft () {
  return true
}
